<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计</el-breadcrumb-item>
      <el-breadcrumb-item>报价转化</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="header">
        <h2>报价转化率</h2>
        <div class="text-info-12">以报价单为起点，通过订单转化率展现销售的转单能力。借此数据，可不断提升销售报价技巧和报价单质量。本统计的时间为报价单的创建时间。</div>
      </div>
      <div class="mt-20">
        <el-form :model="filter" ref="filterForm" label-position="left" label-width="70px">
          <el-form-item label="人员" prop="user_id">
            <el-select v-model="filter.user_id" placeholder size="small">
              <el-option
                v-for="item in saleUsers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="date">
            <el-date-picker
              v-model="filter.date"
              size="small"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" size="small" @click="requestOrderRate()">确定</el-button>
        <el-button size="small" @click="reset()">重置</el-button>
      </div>
    </div>
    <div class="panel mt-20">
      <ve-line :data="orderRateData" :settings="orderRateDataSetting"></ve-line>
    </div>
    <div class="panel mt-20">
      <el-table :data="orderRateData.rows">
        <el-table-column prop="月份" label="月份"></el-table-column>
        <el-table-column prop="报价单数" label="报价单数"></el-table-column>
        <el-table-column prop="订单数" label="订单数"></el-table-column>
        <el-table-column prop="转化率" label="转化率">
          <template slot-scope="scope">
            <span>{{ scope.row['转化率'].toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import { create } from 'mathjs/lib/entry/mainAny'
import { formatTime } from '@/util/index'
import Vue from 'vue'

import {
  customerCoverage,
  orderRate,
  monthSales,
  saleUserList
} from '../../service/getData'
import { clone } from '@/util'
export default {
  data() {
    this.orderRateDataSetting = {
      axisSite: { right: ['转化率'] },
      yAxisType: ['int', 'percent'],
      yAxisName: ['数值', '比率']
    }
    return {
      saleUsers: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().getFullYear(), 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近十二个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 12)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      filter: {
        user_id: 0,
        date: null
      },
      orderRateData: {
        columns: ['月份', '订单数', '报价单数', '转化率'],
        rows: []
      }
    }
  },
  created() {
    this.reset()
    this.requestSaleUsers()
  },
  methods: {
    async requestOrderRate() {
      if (this.filter.date == null || this.filter.date.length != 2) {
        this.$message.error('请选择一个时间范围')
        return
      }

      let data = {
        user_id: this.filter.user_id,
        start: Vue.time(this.filter.date[0]).format('YYYY-MM-DD'),
        end: Vue.time(this.filter.date[1]).format('YYYY-MM-DD')
      }

      let res = await orderRate(data)
      this.orderRateData.rows = res.data.list.map(item => {
        return {
          月份: item.month,
          订单数: item.customer_order,
          报价单数: item.quotation,
          转化率: item.quotation == 0 ? 0 : item.customer_order / item.quotation
        }
      })
    },
    async requestSaleUsers() {
      let res = await saleUserList()
      this.saleUsers = res.data.list
      this.saleUsers.unshift({
        id: 0,
        name: '所有人员'
      })
    },
    reset() {
      if (this.$refs['filterForm']) {
        this.$refs['filterForm'].resetFields()
      }

      const start = new Date()
      start.setMonth(start.getMonth() - 12)
      const end = new Date()
      this.filter.date = [start, end]

      this.requestOrderRate()
    }
  }
}
</script>

<style scoped>
.overview {
  overflow: hidden;
}
.overview dt {
  font-size: 12px;
  color: #555;
  display: block;
  width: 100%;
  line-height: 2;
}

.overview dd {
  width: 33%;
  height: 80px;
  float: left;
  margin: 0;
}

.overview dd span {
  display: block;
  font-size: 24px;
  color: #0087cb;
  text-align: center;
  line-height: 1.6;
}

.overview dd span.title {
  font-size: 12px;
  color: #888;
}

.overview dd span.compare {
  font-size: 12px;
  color: #e6a23c;
}

.overview dd span.text-danger {
  color: #f56c6c;
}
</style>